import { render } from "./PlanetaryTrackReward.vue?vue&type=template&id=634e2132&ts=true"
import script from "./PlanetaryTrackReward.vue?vue&type=script&lang=ts"
export * from "./PlanetaryTrackReward.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__